<template>
  <v-data-table
    dense
    :headers="headers"
    :items="internalValue"
    :items-per-page="-1"
    hide-default-footer
    class="elevation-1 CreditDetails"
  >
    <template v-slot:top>
      <div class="d-flex justify-end">
        <v-btn
          class="mx-2" color="primary"
          fab icon x-small
          @click="addOne"
        >
          <v-icon>
            {{icons.mdiPlus}}
          </v-icon>
        </v-btn>
        <FortePayment
          v-if="renderComponent && forteConfig.isConfigured"
          @forteResponse="forteResponse"
        />
      </div>
    </template>

    <template v-slot:[`item.cardType`]="{ item }">
      <v-select
        dense
        class="credit-card-type"
        v-model="item.cardType"
        :items="cardTypes"
        :rules="cardTypeValidation"
        @change="val => somethingChanged()"
        item-text="description"
        item-value="name"
      ></v-select>
    </template>

    <template v-slot:[`item.amount`]="{ item, index }">
      <v-text-field
        dense
        v-model="item.amount"
        :rules="amountValidation"
        single-line
        class="credit-amount"
        @keydown="shortcutHandler($event, index)"
        @keydown.enter="somethingChanged"
        @blur="somethingChanged();sumAmount()"
      ></v-text-field>
    </template>

    <template v-slot:[`item.actions`]="{ item }">
      <v-icon
        small class="mr-2"
        tabindex="-1"
        @click="removeOne(item)"
      >
        {{icons.mdiDelete}}
      </v-icon>
    </template>

    <template v-slot:[`item.cleared`]="{ item }">
      <v-checkbox
        small class="mr-2 od-credit-iscleared-checkbox"
        v-model="item.isCleared"
        @change="somethingChanged"
      ></v-checkbox>
    </template>

    <template slot="body.append">
      <tr class="blue--text">
          <td colspan="2" id="total-credit-amount">
            Total : ${{ amountFormat(amountRemaining) }}
          </td>
      </tr>
    </template>

  </v-data-table>
</template>

<script>
import {
  mdiPlus,
  mdiDelete,
} from '@mdi/js';

import { mapState } from 'vuex';

import {
  isTabOrPlus,
  amountToNumber,
  amountFormat,
} from '../../util/shared/vue-global';

import FortePayment from '../common/FortePayment.vue';

const defaultItem = {
  cardType: undefined,
  amount: 0,
};

export default {
  name: 'CreditDetails',
  components: {
    FortePayment,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    componentKey: Number,
    depositAmount: [Number, String],
  },
  data: () => ({
    icons: {
      mdiPlus,
      mdiDelete,
    },
    headers: [
      { text: 'Credit Card Type', value: 'cardType' },
      { text: 'Amount', value: 'amount' },
      { text: 'Actions', value: 'actions', sortable: false },
      { text: 'Cleared', value: 'cleared', sortable: false },
    ],
    renderComponent: true,
  }),
  computed: {
    ...mapState({
      cardTypes: (state) => state.enums.ODCardItemTypeEnum,
    }),
    internalValue: {
      get() {
        const newVal = JSON.parse(JSON.stringify(this.value));
        const updatedValue = newVal.map(this.loadInitialValues);
        return updatedValue;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    forteConfig() {
      return this.$store.state.ForteService.forteConfig;
    },
    cardTypeValidation() {
      return [
        (value) => !!value || 'Required',
      ];
    },
    amountValidation() {
      return [
        (value) => !!value || 'Required',
        (value) => value !== 0 || 'Should be non-zero',
      ];
    },
    amountRemaining() {
      let totalRemainingAmount = amountToNumber(this.depositAmount);
      for (let i = 0; i < (this.internalValue || []).length; i += 1) {
        totalRemainingAmount -= amountToNumber(this.internalValue[i].amount);
      }
      return totalRemainingAmount;
    },
  },
  watch: {
    componentKey() {
      this.forceRerender();
    },
  },
  methods: {
    amountToNumber,
    amountFormat,
    loadInitialValues(item) {
      return {
        ...item,
        amount: amountFormat(amountToNumber(item.amount)),
      };
    },
    shortcutHandler(e, index) {
      if (isTabOrPlus(e)) {
        if ((index + 1) === (this.internalValue || []).length) {
          this.sumAmount();
          this.somethingChanged();
          if (amountToNumber(this.depositAmount) > this.sumAmount()) {
            this.addOne();
          }
        }
      }
    },
    addOne() {
      this.$emit('input', [
        ...this.internalValue,
        {
          ...defaultItem,
        },
      ]);
      return true;
    },
    removeOne(item) {
      // const indexOfRemove = this.internalValue.indexOf(item);
      this.$emit('input', [
        ...this.internalValue.filter((candidate) => item !== candidate),
      ]);
    },
    somethingChanged() {
      this.$emit('input', this.internalValue);
    },
    forteResponse(response) {
      this.$emit('forteResponse', response);
    },
    forceRerender() {
      // Remove forte-component from the DOM
      this.renderComponent = false;

      this.$nextTick(() => {
        // Add the forte-component back in
        this.renderComponent = true;
      });
    },
    sumAmount() {
      let totalSum = 0.00;
      for (let i = 0; i < this.internalValue.length; i += 1) {
        totalSum += amountToNumber(this.internalValue[i].amount);
      }
      return totalSum;
    },
  },
};
</script>

<style lang="sass">
  .credit-amount input
    text-align: right
</style>
